export const SearchConf = {
  query: {
    keys: [
      {
        key: 'mexal_code',
        operator: '$containsi',
      },
      {
        key: 'label',
        operator: '$containsi',
      },
      {
        key: 'company_name',
        operator: '$containsi',
      },
      {
        key: 'id_sub_category.name',
        operator: '$containsi',
      },
      {
        key: 'id_category.name',
        operator: '$containsi',
      },
      {
        key: 'supplier_contacts.main_contact',
        operator: '$containsi',
      },
      {
        key: 'notes',
        operator: '$containsi',
      },
    ],
  },
  placeholder:
    'Search by Mexal Code, Supplier, Name, Main Contact, Notes, Category or Sub-category',
  initialState: {
    value: '',
  },
};
